import React, { createContext, useContext, useState, useEffect } from 'react';

// Sizes: xs=10px, sm=12px, md=14px (default), lg=16px, xl=18px
const SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
const DEFAULT_SIZE = 'md';

const FontSizeContext = createContext(null);

export function FontSizeProvider({ children }) {
  const [size, setSize] = useState(() => {
    const saved = localStorage.getItem('tableFontSize');
    return SIZES.includes(saved) ? saved : DEFAULT_SIZE;
  });

  useEffect(() => {
    SIZES.forEach((s) => document.documentElement.classList.remove(`table-font-${s}`));
    document.documentElement.classList.add(`table-font-${size}`);
    localStorage.setItem('tableFontSize', size);
  }, [size]);

  const decrease = () => setSize((s) => SIZES[Math.max(0, SIZES.indexOf(s) - 1)]);
  const increase = () => setSize((s) => SIZES[Math.min(SIZES.length - 1, SIZES.indexOf(s) + 1)]);
  const canDecrease = SIZES.indexOf(size) > 0;
  const canIncrease = SIZES.indexOf(size) < SIZES.length - 1;

  return (
    <FontSizeContext.Provider value={{ size, decrease, increase, canDecrease, canIncrease }}>
      {children}
    </FontSizeContext.Provider>
  );
}

export function useFontSize() {
  return useContext(FontSizeContext);
}
